export default {
  topHeader: {
    buttonText: 'Use App',
    shareImg: '/webAssets/images/img/browser_EN.png'
  },
  articles: {
    likes: 'likes',
    comments: 'comments',
    reply: 'reply',
    noData: 'No more data'
  },
  brandAuth: {
    htmlTitle: 'Request verification',
    bannerImg: '/webAssets/images/brand/banner3.jpg',
    textInfo: [
      'Complete MINGCHU verification',
      'Complete MINGCHU verification in order to promote your products, interact with high-end chefs, participate in activities such as live streaming, and trial etc.',
      'After submitting the verification application, our staff will get in touch with you.'
    ],
    formText: {
      nameText: { label: "Applicant's name", placeholder: "Type applicant's name" },
      unitText: { label: 'Company name', placeholder: 'Type company name' },
      telText: { label: 'Phone number', placeholder: 'Type phone number' },
      desText: { label: 'Brand introduction', placeholder: 'Type brand introduction' },
      submitText: { label: 'Submit', placeholder: 'Submitted successfully', dbApply: "Don't repeat submission" }
    }
  },
  // 2020名厨个人年度报告
  AnnualReportIndex: {
    agreementChecked: 'You must agree to the Privacy Policy to proceed.'
  },
  annualReport: {
    chefType: [
      {
        i: 'I am an ',
        a: '',
        type: 'Influencer',
        title: 'Willing to express oneself',
        info: 'Having a certain status in the industry, is willing to influence others with professional knowledge and opinions. '
      },
      {
        i: 'I am ',
        a: '',
        type: 'Evolving',
        title: 'Always improving and growing',
        info: 'Having professional recognition in the industry, is always willing to work on ones goals to evolve into a decision-maker.'
      },
      {
        i: 'I am an ',
        a: '',
        type: 'Explorer',
        title: 'Open to innovation and change',
        info: 'Willing to try and learn new things, the career path and goals are yet to be explored.'
      },
      {
        i: 'I am a ',
        a: '',
        type: 'Logistician',
        title: 'Persistent in quality and presentation',
        info: 'Having a stable carreer, have become the logistian of ones professional and personal life.'
      },
      {
        i: 'I am a ',
        a: '',
        type: 'Professional',
        title: 'Facing challenges and seeking growth',
        info: 'Working to live and not living to work, lacks opportunities and career evolution.'
      }
    ],
    shareBtn: 'Share',
    goIndex: 'View Again',
    keepPic: 'Save Photo',
    shareXcx: 'Long Press To Share Photo'
  },
  oftenImmersed: {
    isTrue: 'You nailed it!',
    isError: 'Almost there...',
    h4: 'My Favorite Content',
    choose: 'Make your choice',
    more: {
      a1: 'You are more active than',
      a2: 'of our users'
    },
    CreationsandInspiration: 'Creations & Inspiration',
    LiveStreaming: 'Live Streaming',
    Articles: 'Articles',
    Collections: 'Collections',
    Videos: 'Videos',
    one: {
      a1: "Wow, you're really into",
      a2: '!'
    },
    beMore: 'Be more active to get your commitment level.'
  },
  interestedCuisine: {
    title: 'My Favorite Cuisines'
  },
  myFavoriteWorks: {
    title: 'My Favorite Creation'
  },
  myFavoriteWorksList: {
    title: 'My Favorite Collection',
    saveCollection: 'Save Collection',
    tip: 'Saved to "Saved Items"',
    myfavoriteof2020: '#myfavoriteof2020'
  },
  otherFavoriteWorks: {
    title: 'My Top Creation',
    message: {
      a1: '*Your popularity is subject to the views,',
      a2: 'likes, saves and shares your creations get.'
    }
  },
  otherFavoriteWorksList: {
    title: 'Top Collection',
    saveCollection: 'Save Collection',
    tip: 'Saved to "Saved Items"',
    otherfavoriteof2020: '#bestof2020'
  },
  follow: {
    title: 'Who Followed Me',
    choose: 'Take a guess'
  },
  matchChefType: {
    title: 'Your Chef Type'
  },
  shareInfo: {
    title: 'MINGCHU 2020 Annual Report',
    desc: 'A review for chefs. '
  },
  index2021: {
    'home': {
      title: '2020-2021 MINGCHU INDEX',
      name: '2020-2021 MINGCHU INDEX',
      tip: "The Lists of 2020-2021 MINGCHU INDEX are based on our users' behaviors data, therefore resulting in the view of our users towards creations, content and ingredients on the app.",
      share_title: '2020-2021 MINGCHU INDEX',
      share_des: 'Unveiling 12 Lists by MINGCHU'
    },
    'food': { // 作品人气王
      title: 'Most Votes - Creations',
      name: 'Most Votes<br/>Creations',
      tip: 'The list shows the most voted 50 creations of the year 2020.<br/>*The data is based poll results.',
      share_title: '2020-2021 MINGCHU INDEX Most Votes - Creations',
      share_des: 'The Most Voted Creations of the Year'
    },
    'chinese_food': { // 中餐
      title: 'Trending - Chinese Cuisine',
      name: 'Trending<br/>Chinese Cuisine',
      tip: 'The list shows the most trending 50 creations of Chinese cuisine of the year 2020.<br/>*The data is based on the amount of views, likes, comments, saves on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Chinese Cuisine',
      share_des: 'The Culinary Trends of the Year'
    },
    'live': { // 直播
      title: 'Trending - Live Streaming',
      name: 'Trending<br/>Live Streaming',
      tip: 'The list shows the most trending 20 live videos of the year 2020.<br/>*The data is based on the amount of viewers, bullets screens, saves and shares on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Live Streaming',
      share_des: 'The Most Popular Live Videos of the Year'
    },
    'condiment': { // 调味品
      title: 'Trending - Condiments',
      name: 'Trending<br/>Condiments',
      tip: 'The list shows the most trending 20 condiments of the year 2020.<br/>*The data is based on condiments from creations, taking into consideration their quantity and quality during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Best of Year - Condiments',
      share_des: 'The Most Popular Condiments of the Year'
    },
    'dessert': { // 甜品
      title: 'Trending - Pastry',
      name: 'Trending<br/>Pastry',
      tip: 'The list shows the most trending 50 creations in pastry section of the year 2020.<br/>*The data is based on the amount of views, likes, comments, saves on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Pastry',
      share_des: 'The Culinary Trends of the Year'
    },
    'first': { // 首发作品
      title: 'Trending - MINGCHU Premiere',
      name: 'Trending<br/>MINGCHU Premiere',
      tip: 'The list shows the most trending 10 creations in MINGCHU premiere section of the year 2020.<br/>*The data is based on the amount of views, likes, comments, saves on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - MINGCHU Premiere',
      share_des: 'The Most Popular Premieres of the Year'
    },
    'ingredient': { // 食材
      title: 'Trending - Ingredients',
      name: 'Trending<br/>Ingredients',
      tip: 'The list shows the most trending 20 ingredients of the year 2020.<br/>*The data is based on ingredients from creations, taking into consideration their quantity and quality during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Ingredients',
      share_des: 'The Most Popular Ingredients of the Year'
    },
    'chef': { // 厨师人气王
      title: 'Most Votes - Chefs',
      name: 'Most Votes<br/>Chefs',
      tip: 'The list shows the most voted 50 chefs of the year 2020.<br/>*The data is based poll results.',
      share_title: '2020-2021 MINGCHU INDEX Most Votes - Chefs',
      share_des: 'The Most Voted Chefs of the Year'
    },
    'brand': { // 品牌
      title: 'Trending - Brands',
      name: 'Trending<br/>Brands',
      tip: 'The list shows the most trending 10 brands of the year 2020.<br/>*The data is based on live videos, trial and moments on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Brands',
      share_des: 'The Most Popular Brands of the Year'
    },
    'user': { // 名厨达人
      title: 'Trending - Creators',
      name: 'Trending<br/>Creators',
      tip: 'The list shows the most active 50 creators of the year 2020.<br/>*The data is based on the engagment of MINGCHU users in 2020.',
      share_title: '2020-2021 MINGCHU INDEX Trending - Creators',
      share_des: 'The Most Active Creators of the Year'
    },
    'non_chinese_food': { // 非中餐
      title: 'Trending - Non-Chinese Cuisine',
      name: 'Trending<br/>Non-Chinese Cuisine',
      tip: 'The list shows the most trending 50 creations of non-Chinese cuisine of the year 2020.<br/>*The data is based on the amount of views, likes, comments, saves on the app during 2020. ',
      share_title: '2020-2021 MINGCHU INDEX Trending - Non-Chinese Cuisine',
      share_des: 'The Culinary Trends of the Year'
    },
    'author': { // 出品人
      title: 'Best of Year - Creators',
      name: 'Best of Year<br/>Creators',
      tip: 'The list shows the most popular 50 creators of the year 2020.<br/>*The data is based on the high-quality creations posted by MINGCHU users in 2020.',
      share_title: '2020-2021 MINGCHU INDEX Best of Year - Creators',
      share_des: 'The Most Popular Creators of the Year'
    },
    vote: {
      showText: 'Results On',
      openText: 'Polls Open On',
      nowText: 'Polls Open Until',
      endText: 'Results On'
    },
    classText: 'en',
    topTitleClass: 'icon_top_en',
    bottomDes: 'MINGCHU reserves the right of final interpretation for the content hereinabove.',
    gobackBtn: 'Go Back',
    saveBtn: 'Save Collection',
    savedBtn: 'Saved to “Saved Items”',
    saveText: 'Save',
    savedText: 'Saved',
    followText: 'Follow',
    followingText: 'Following',
    followingAllText: 'Following',
    timesUsedText: 'Times Used',
    voteText: 'Vote'
  },
  auth: {
    home: {
      bannerText1: 'MINGCHU Verification',
      bannerText2: 'Get Verified<br>For More Benefits',
      nameText1: 'ID Verification',
      nameText2: 'Secure Your Account<br>Increase Your Exposure<br>Hand-Picked Creations',
      opnText1: 'For Professionals',
      opnText2: 'Professional Badge<br>Featured on Homepage<br>Event Priority Pass',
      bnsText1: 'For Brands',
      bnsText2: 'Increase Brand Exposure<br>Intiate Exclusive Events<br>User-Centric Marketing',
      authHelp: 'FAQ about Verification',
      authSuccess: 'Verified',
      authWait: 'Under Review',
      authFail: 'Failed',
      authNo: 'Verify'
    },
    aiAuth: {
      title1: 'ID Verification',
      title2: 'Face ID',
      formText1: 'Name',
      placeholder1: 'Type your real name',
      formText2: 'ID Type',
      placeholder2: 'Choose your ID type',
      formText3: 'ID No',
      placeholder3: 'Type your ID number',
      nextText: 'Next',
      cardText1: 'Mainland China',
      cardText2: 'Hong Kong, Macau & Taiwan',
      cardText3: 'Overseas',
      cancel: 'Cancel',
      aiText1: 'Face Recognition',
      aiText2: 'I agree to ',
      aiText22: 'MINGCHU\'s Privacy Policy',
      aiText3: 'Get Started',
      againAuth: 'Retry',
      statusTip1: 'Recognition Failed',
      statusTip2: 'Get Started',
      statusTip3: 'Please try again',
      statusTip4: 'Your data is encrypted',
      statusTip5: 'Manual Review',
      statusTip6: 'Your data shall not be shared without your consent.',
      statusTip7: 'If you opt for manual review you need to upload your ID. Review period usually takes 2 working days.',
      statusTip8: 'Your data shall be used for verification purposes.'

    },
    nameAuth: {
      formText4: 'Photo',
      formText44: 'Help',
      formText5: 'How to Upload',
      formText6: 'How to Upload',
      formTip1: 'Upload your ID',
      btnText1: 'Submit',
      statusTip1: 'The review process takes 2 working days',
      statusTip2: 'Please try again',
      statusTip3: 'Not working? Try',
      statusTip33: 'Face ID instead',
      statusTip4: 'Upload one of following documents',
      statusTip5: 'The photo must be clear and the ID shall belong to the individual whose information is being verified.',
      imgTip1: 'ID Front',
      imgTip2: 'ID Back',
      imgTip3: 'ID',
      imgTip4: 'Passport',
      imgTip5: 'Driver\'s License',
      isKnow: 'OK'
    },
    opnAuth: {
      title: 'For Professionals',
      iconText1: 'Badge',
      iconText2: 'Featured',
      iconText3: 'Priority Pass',
      iconText4: 'And More...',
      titleText: 'How to Apply',
      titleText1: 'Current Identity',
      titleText2: 'ID Verification',
      titleText22: 'Not Verified',
      titleText3: 'Followers',
      itleText33: 'Current Followers',
      titleText4: 'Complete Creations',
      titleText44: 'Current Creations',
      statusText1: 'Verify',
      statusText2: 'Done',
      statusText3: 'Not Yet',
      statusText4: 'Completed',
      statusText5: 'Verified',
      statusText6: 'Apply',
      formText1: 'Company',
      formText2: 'Title',
      formText3: 'Upload',
      formTip1: 'Upload one of following documents. Your name, company and title should be clear and belong to you.',
      formTip2: 'Job Proof',
      formTip3: 'Work Permit',
      formTip4: 'Business Card',
      formTip5: 'Download Template',
      formTip55: 'Please upload the document above after you stamp it.',
      formTip6: 'How to Upload',
      formTip7: 'Your name, company and title should be clear.',
      formTip8: 'Your name, company and title should be clear and the business card shall be hold as the picture above.',
      formTip9: 'The photo must be clear and the ID shall belong to the individual whose information is being verified.',
      identityText1: 'Chef',
      identityText2: 'Manager',
      identityText3: 'Supplier',
      identityText4: 'Foodie',
      userText1: 'ID Type',
      userText2: 'Mainland China',
      userText3: 'Hong Kong, Macau & Taiwan',
      userText4: 'Overseas',
      userText5: 'ID',
      userText6: 'Driver\'s License',
      userText7: 'Passport'
    },
    brandAuth: {
      text0: 'For Businesses',
      text1: 'Profile Picture',
      text2: 'Account',
      text3: 'Slogan',
      text4: 'Description',
      text5: 'Company',
      text6: 'Registration No',
      text7: 'Extra Materials',
      text8: 'Business License',
      text9: 'Verification Letter',
      text10: 'Delete This Account',
      text11: 'Are you sure?',
      text12: 'Deleted account cannot be recovered.',
      text13: 'Photos should be clear and corespond to your account.',
      text14: 'Photos should be clear and corespond to your account.',
      text14_1: 'Please upload the document above after you stamp it.',
      text15: 'Verification Info',
      text16: 'Verification Materials',
      text18: 'More',
      text18_1: 'collect',
      text19: 'As Registered',
      text20: 'Optional',
      text21: 'Extra Material',
      text22: 'You may be required to provide such as Weibo Verification Proof.',
      text23: 'Documents',
      text24: 'Please input the content',
      text25: 'Download Template',
      text26: 'Please stamp before uploading.',
      text27: 'Upload'
    }
  },
  bigEvent: {
    winning: {
      fabu: 'Create Event',
      prizehead: 'More Winners',
      choicespan: 'Podium Creations',
      btnchoice: 'Choose Creation',
      prizebtn: 'Post Outcome',
      prizebtns: 'Podium Creations',
      pluswinning: 'Add a Place',
      toast: 'You may add up to five places',
      onSearch: 'Search for creations or users',
      awards: 'Podium Creations',
      numberone: ['1st Place ', '2nd Place ', '3rd Place ', '4th Place ', '5th Place '],
      Tips: ['Delete Place?', 'This will affect the Podium Creations. Are you sure?', 'No', ' Yes'],
      Tipss: ['Delete Place?', 'Do you want to save changes?', "Don't Save", 'Save'],
      delete: 'Delete',
      Calorific: 'Sort by Popularity',
      Release: 'Sort by Time',
      votes: 'Sort by Votes',
      Confirmation: 'OK',
      Tip: ['Delete Place?', 'Podium Creations cannot be edited after going live. Are you sure you want to continue?', 'No', 'Yes'],
      mode: [' by', 'won', 'Please contact us in tree days to redeem your award.']
    },
    info: {
      text1: 'Suggested for You',
      text3: [' views', ' members'],
      text3_1: 'All users can join',
      text4: 'About',
      text5: 'Creations',
      text6: 'Follow',
      text7: 'Award',
      text8: 'How to Join',
      text9: 'Details',
      text10: 'Recommended',
      text11: 'Trending',
      text12: 'Newest',
      text12_1: 'No Creations Yet',
      text13: 'Starting in',
      text14: 'Join',
      text14_1: 'Please update to the latest version to join the event.',
      text14_2: 'Update',
      text14_3: 'Cancel',
      text14_4: ['Sorry, you already joined', 'times. Try next time.'],
      text15: 'Selecting Winners',
      text15_1: 'Selection Ended',
      text16: 'Event Ended',
      text17: 'Upcoming',
      text18: 'In Progress',
      text19: 'Shortlist',
      text20: 'Ended',
      text22: 'You are attending',
      text23: 'Attending',
      text24: 'Entry',
      text25: 'Shortlist',
      text26: 'Outcome',
      text27: 'Vote',
      text28: 'Top 10',
      text29: 'You reached the limit of 10 votes per day.',
      text29_1: 'You reached the limit of x votes.',
      text30: ['This creation is part of the event ', '. Vote here >>'],
      text30_1: ['This creation is part of the event ', '. View stats >>'],
      text31: ['I am', 'I am attending ', ''],
      text31_1: 'Share Event',
      text31_2: 'Invite Friends',
      text31_3: 'Cancel',
      text32: 'Place',
      text33: 'Votes',
      text34: 'For Next Place',
      text35: 'Invite Friends to Vote',
      text35_1: 'Check out this event I\'m attending.',
      text35_2: 'Vote for me! ',
      text35_3: 'View Event',
      text36: 'Vote',
      text36_1: 'Share',
      text37: 'View Podium Creations',
      text37_1: 'Choose Your Creation',
      text37_2: 'Coming Soon',
      text38: 'Outcome',
      text39: 'Podium Creations',
      text40: 'Events',
      text41: 'Events',
      text42: 'Not Approved',
      text43: 'Pending',
      text44: 'Live',
      text45: 'Details',
      text46: 'Analytics',
      text47: 'Create Event',
      text48: 'Events you created will appear here. Get started by creating a new event.',
      text49: 'Details',
      text50: 'Edit',
      text50_1: ['If you need to edit the event after it goes live, please contact us via WeChat at xiaoqilaile.', 'OK'],
      text50_2: 'If you need to edit the event during the review period, please contact us via WeChat at xiaoqilaile.',
      text51: 'Outcome',
      text51_1: 'You can only post the outcome after the selection phase.',
      text52: 'More',
      text52_1: 'Analytics',
      text53: 'Creations',
      text54: 'Members',
      text55: 'Views',
      text56: 'Saves',
      text57: 'Votes',
      text58: 'Shares',
      text59: 'Delete',
      text59_1: ['Are you sure you want to delete?', 'Yes', 'Cancel'],
      text59_2: ['You cannot delete events with participants.', 'OK'],
      text60: 'Create Event',
      text61: 'Event Type',
      text62: ['Online', 'No registration is required, users can join directly. You may edit selection type and choose whether or not to include awards.'],
      text63: 'View Event Template',
      text64: 'More event types coming soon.',
      text65: 'Edit Cover Photo',
      text66: 'Upload Photo',
      text67: '250*121px | less than 5MB',
      text68: ['About', 'Event Name'],
      text69: 'Event Type',
      text70: 'Time',
      text70_1: 'Pick Event Time',
      text70_2: 'Start time cannot be earlier than current time.',
      text70_3: 'End time cannot be earlier than current time.',
      text71: 'Include Selection Phase',
      text72: 'Selection Period',
      text73: 'Details',
      text74: 'Selection Type',
      text74_1: 'Voting',
      text74_2: 'Handpicked',
      text75: 'Voting Requirements',
      text75_1: 'Registered User',
      text75_2: 'Verified User',
      text75_3: 'None',
      text76: 'Voting Daily Limit',
      text77: 'Voting Total Limit',
      text78: 'Voting Deadline',
      text79: 'Event Hashtags',
      text80: 'Attendace Limit',
      text81: 'Save Draft',
      text81_1: 'Saved to Drafts',
      text82: 'Preview',
      text83: 'Next',
      text84: 'Include Awards',
      text85: 'Create Event',
      text85_1: ['About Briefly introduce the event.',
        'Awards Fill in the awards.',
        'How to Join Explain how to join.',
        'Details Point out any special requirements.'],
      text85_2: ['Your event needs to be approved before it can go live. We will contact you within 48 hours after we finish the review process.      ',
        'OK'],
      text85_3: 'Please don\'t exceed the character limit.',
      text85_4: ['Text', 'Photo'],
      text86: ['I read', '"MINGCHU Events Rules"', ', and I guarantee the event is real.'],
      text86_1: ['Do you want to save changes?', 'Save ', 'Don\'t Save'],
      text86_2: 'Please choose a photo.',
      text86_3: 'Please fill in the name of the event.',
      text86_4: 'Please pick the event time.',
      text86_5: 'Please pick the selection period.',
      text86_6: 'Please pick the voting deadline.',
      text87_1: 'Back',
      text87_2: 'Create Event',
      text87_3: 'This page is for preview only. ',
      text88_1: 'Under Review',
      text88_2: 'The review process may take up to 48 h.',
      text89: 'Not Approved | Try Again',
      text89_1: 'Your event was not approved. Please try again.',
      text90: 'This event was deleted by the host.',
      text90_1: 'Back to Home',
      text92: 'Selection period cannot be earlier than event time.',
      text93: 'Voting deadline cannot be earlier than selection period.',
      text94: '',
      text94_1: 'Edit Creation',
      text95: '',
      text96: '',
      text97: '',
      text98: '',
      text99: '',
      text99_1: 'Search Results',
      text99_2: 'The creation or user you search for does not exist',
      text99_3: 'No Creations',
      text100: '',
      text101: '',
      text102: '',
      text102_3: 'Selected Creations',
      text103: '',
      text103_1: 'Popularity',
      text104: '',
      text105: '',
      text106: 'Event Cover Photo',
      text107: '',
      text108: 'How to Upload',
      text109: 'Event Photos',
      text110: 'Event Thumbnail',
      text111: '750*480px | up to 5 photos | less than 5MB',
      text112: 'Touch to move the photo',
      text113: 'First Photo',
      text114: 'Move Down',
      text115: 'Move Up',
      text115_1: 'OK',
      text116: '',
      text117: '',
      text118: '',
      text119: '',
      text120: 'That\'s all',
      text121: 'Event',
      text122: 'Over',
      time1: '-',
      time2: ['', '', ' ', ':', ''],
      class1: 'english'
    }
  }
}
